var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;stroke:#fff;}.a{opacity:0;}.b{stroke-width:0.3px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10413 3263)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-10413 -3263)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10420.328 -3259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.328 8.522)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.453,257.323a8.134,8.134,0,0,0-8.125,8.125.353.353,0,1,0,.707,0,7.418,7.418,0,1,1,14.837,0,.353.353,0,1,0,.707,0A8.134,8.134,0,0,0,19.453,257.323Z",
    transform: "translate(-11.328 -257.323)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.567)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143.214,0A3.886,3.886,0,1,0,147.1,3.886,3.89,3.89,0,0,0,143.214,0Zm0,7.065a3.179,3.179,0,1,1,3.179-3.179A3.183,3.183,0,0,1,143.214,7.065Z",
    transform: "translate(-139.328)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInfo);
export default __webpack_public_path__ + "static/media/generalInfo.e686420e66827f2b74cd7cc35a736c9a.svg";
export { ForwardRef as ReactComponent };